import { Injectable } from "@angular/core";
import { Params } from '@angular/router';
import { Observable } from 'rxjs';
import { getLanguage, getLanguageFromUrl } from '../language';
import { Acabado, CaracteristicaMaterial, ColorMaterial, Continente, DetalleStock, Bookmatch, Disponibilidad, Espesor, Maestros, Material, RangoPrecio, Stock, TipoMaterial, UsoMaterial, UnidadMedida, getUnidadMedida } from "../models";
import { ApiRoute, ApiService } from "./api.service";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaterialesService {
  constructor(private apiService: ApiService) {}

  async getMaestros(): Promise<Maestros> {
    try {
      return {
        tipoMaterial: await this.apiService.get<TipoMaterial[]>(ApiRoute.TIPOLOGIA).toPromise(),
        acabado: await this.apiService.get<Acabado[]>(ApiRoute.ACABADO).toPromise(),
        colorMaterial: await this.apiService.get<ColorMaterial[]>(ApiRoute.COLOR).toPromise(),
        usoMaterial: await this.apiService.get<UsoMaterial[]>(ApiRoute.USOS).toPromise(),
        continente: await this.apiService.get<Continente[]>(ApiRoute.ORIGEN).toPromise(),
        espesor: await this.apiService.get<Espesor[]>(ApiRoute.ESPESOR).toPromise(),
        disponibilidad: await this.apiService.get<Disponibilidad[]>(ApiRoute.DISPONIBILIDAD).toPromise(),
        rangoPrecio: await this.apiService.get<RangoPrecio[]>(ApiRoute.RANGO_PRECIO).toPromise(),
        materiales: await this.apiService.get<Material[]>(ApiRoute.MATERIALES).toPromise(),
        caracteristicasMaterial: await this.apiService.get<CaracteristicaMaterial[]>(ApiRoute.CARACTERISTICAS).toPromise()
      }
    } catch (err) {
      throw err;
    }
  }

  getStock(params: string[]): Observable<Stock[]> {
    return this.apiService.get<Stock[]>(ApiRoute.STOCK, params);
  }

  getResultsCount(params: string[]): Observable<string> {
    return this.apiService.get<string>(ApiRoute.STOCK_COUNT, params, '/count');
  }

  serializeDetailsParams(item: Stock): Params {    
    if (environment.byBundle)
    {
      return {
        bloque: item.BLOQUE,
        material: item.MATERIAL,
        acabado: item.ACABADO,
        ancho: item.ANCHO,
        //grupo: item.GRUPO
      };
    }

    return {
      bloque: item.BLOQUE,
      material: item.MATERIAL,
      acabado: item.ACABADO,
      ancho: item.ANCHO
    };
  }

  deserializeDetailsParams(queryParams: Params): string[] {
    let params: string[] = [];
    for(const key in queryParams) {
      params.push(`${key}=${queryParams[key]}`);
    }
    return params;
  }

  getDetalles(params: string[]): Observable<DetalleStock[]> {
    return this.apiService.get<DetalleStock[]>(ApiRoute.DETALLE, params);
  }

  getNombreMaterial(codigo: Material['CODIGO'], maestros: Maestros | undefined): string {
    if(!maestros) return '';
    const material: Material = maestros.materiales.find(material => material.CODIGO === codigo);
    if(!material) return '';
    return material.NOMBRE;
  }

  getNombreTipoMaterial(codigo: Material['CODIGO'], maestros: Maestros | undefined): string {
    if(!maestros) return '';
    const material: Material = maestros.materiales.find(material => material.CODIGO === codigo);
    if(!material) return '';
    const tipoMaterial: TipoMaterial = maestros.tipoMaterial.find(m => m.TIPOMATERIALID === material.TIPOMATERIALID);
    if(!tipoMaterial) return '';
    return tipoMaterial.DESCRIPCION;
  }

  getAcabadoMaterial(codigo: Acabado['CODIGO'], maestros: Maestros | undefined): string {
    if(!maestros) return '';
    const acabado: Acabado = maestros.acabado.find(acabado => acabado.CODIGO === codigo);
    if(!acabado) return '';
    return acabado.NOMBRE;
  }

  getAncho(val: string): string {
    return `${val} cm`
  }

  //getDiponibilidadMaterial(codigo: Material['CODIGO'], maestros: Maestros | undefined): string {
    getDiponibilidad(codigo: Disponibilidad['CODIGO'], maestros: Maestros | undefined): string {
    if(!maestros) return '';
    // const material: Material = maestros.materiales.find(material => material.CODIGO === codigo);
    // if(!material) return '';
    const disponibilidad: Disponibilidad = maestros.disponibilidad.find(disponibilidad => disponibilidad.CODIGO === codigo);
    if(!disponibilidad) return '';
    return disponibilidad.DESCRIPCION;
  }

  getColorMaterial(codigo: Material['CODIGO'], maestros: Maestros | undefined): string {
    if(!maestros) return '';
    const material: Material = maestros.materiales.find(material => material.CODIGO === codigo);
    if(!material) return '';
    const colorMaterial: ColorMaterial = maestros.colorMaterial.find(colorMaterial => colorMaterial.COLORMATERIALID === material.COLORMATERIALID);
    if(!colorMaterial) return '';
    return colorMaterial.DESCRIPCION;
  }

  getContinente(id: Continente['CONTINENTEID'], maestros: Maestros | undefined): string {
    if(!maestros) return '';
    const continente: Continente = maestros.continente.find(con => con.CONTINENTEID === id);
    if(!continente) return '';

  }

  getUsoMaterial(codigo: Material['CODIGO'], maestros: Maestros | undefined): string {
    if(!maestros) return '';
    const material: Material = maestros.materiales.find(material => material.CODIGO === codigo);
    if(!material) return '';
  }

  getMedida(medida: number, unidad: UnidadMedida): string {
    const divisor: number = unidad === UnidadMedida.CM ? 100 : 1;
    const unidadStr: string = unidad === UnidadMedida.CM
    ? getLanguage(getLanguageFromUrl()).METROS
    : getLanguage(getLanguageFromUrl()).PULGADAS
    return `${medida / divisor} ${unidadStr}`;
  }
  getMedidaAncho(item: Stock, unidad: UnidadMedida): string {
    const medida: number = parseFloat(unidad === UnidadMedida.CM ? item.MINLARGO : item.MINLARGOIN);
    return this.getMedida(medida, unidad);
  }
  getMedidaAlto(item: Stock, unidad: UnidadMedida): string {
    const medida: number = parseFloat(unidad === UnidadMedida.CM ? item.MINALTO : item.MINALTOIN);
    return this.getMedida(medida, unidad);
  }

  getRangoMedidaAncho(item: Stock, unidad: UnidadMedida): string {
    const minlargo: number = parseFloat(unidad === UnidadMedida.CM ? item.MINLARGO : item.MINLARGOIN);
    const maxlargo: number = parseFloat(unidad === UnidadMedida.CM ? item.MAXLARGO : item.MAXLARGOIN);
    const divisor: number = unidad === UnidadMedida.CM ? 100 : 1;
    const unidadStr: string = unidad === UnidadMedida.CM
    ? getLanguage(getLanguageFromUrl()).METROS
    : getLanguage(getLanguageFromUrl()).PULGADAS
    return `${minlargo / divisor} - ${maxlargo / divisor} ${unidadStr}`;
  }

  getRangoMedidaAlto(item: Stock, unidad: UnidadMedida): string {
    const minalto: number = parseFloat(unidad === UnidadMedida.CM ? item.MINALTO : item.MINALTOIN);
    const maxalto: number = parseFloat(unidad === UnidadMedida.CM ? item.MAXALTO : item.MAXALTOIN);
    const divisor: number = unidad === UnidadMedida.CM ? 100 : 1;
    const unidadStr: string = unidad === UnidadMedida.CM
    ? getLanguage(getLanguageFromUrl()).METROS
    : getLanguage(getLanguageFromUrl()).PULGADAS
    return `${minalto / divisor} - ${maxalto / divisor} ${unidadStr}`;
  }

  getUsosMaterial(detalle: DetalleStock): Observable<UsoMaterial[]> {
    return this.apiService.get<UsoMaterial[]>(ApiRoute.USOS_MATERIAL,
      [`material=${detalle.MATERIAL}`, `acabado=${detalle.ACABADO}`, `espesor=${detalle.ANCHO}`]);
  }

  getCaracteristicasMaterial(detalle: DetalleStock): Observable<CaracteristicaMaterial[]> {
    return this.apiService.get<CaracteristicaMaterial[]>(ApiRoute.CARACTERISTICAS_MATERIAL,
      [`material=${detalle.MATERIAL}`, `acabado=${detalle.ACABADO}`, `espesor=${detalle.ANCHO}`]);
  }


  async getIconosMaterial(detalle: DetalleStock, maestros: Maestros): Promise<{ icon: string, description: string }[]> {
    if(!maestros || !detalle) return [];

    const material: Material = maestros.materiales.find(material => material.CODIGO === detalle.MATERIAL);
    if(!material) return [];
    const continente: Continente = maestros.continente.find(con => con.CONTINENTEID === material.CONTINENTEID);
    const usosMaterial: UsoMaterial[] = await this.getUsosMaterial(detalle).toPromise();
    const caracteristicasMaterial: CaracteristicaMaterial[] = await this.getCaracteristicasMaterial(detalle).toPromise();
    const rangoPrecio:RangoPrecio = maestros.rangoPrecio.find(rang => detalle.RANGOPRECIO === rang.CODIGO);
    return [
      //detalle.LIBRO == "1" && {icon: "assets/img-svg/icons/libro-1.svg", description: 'bookmatch'},
      continente && {icon: continente.ICONOURL, description: continente.DESCRIPCION},
      ...usosMaterial.map(uso => {
        return {icon: uso.ICONOURL, description: uso.DESCRIPCION}
      }),
      ...caracteristicasMaterial.map(car => {
        return {icon: car.ICONOURL, description: car.DESCRIPCION}
      }),
      rangoPrecio && {icon: rangoPrecio.ICONOURL, description: rangoPrecio.DESCRIPCION}
    ];
  }

  getMaterialesSimilares(param: string) {
    return this.apiService.get<Material[]>(ApiRoute.MATERIALES_SIMILARES, [param]);
  }

  getMaterial(codigo: Material['CODIGO']): Observable<Material[]> {
    return this.apiService.get<Material[]>(<ApiRoute>(ApiRoute.MATERIALES + '/' + codigo));
  }

  getBookmatch(bloque: DetalleStock['BLOQUE']): Observable<Bookmatch[]> {
    return this.apiService.get<Bookmatch[]>(ApiRoute.IMAGEN_LIBRO, [`ID=${bloque}`]);
  }

}
